// core
import React from "react";
import Icon from "../../Icon/Icon";
import cx from "classnames";

interface IValidationMessageProps {
    className?: string;
    isCentered?: boolean;
}

const ValidationMessage: React.FC<IValidationMessageProps> = ({
    isCentered,
    children
}) => {
    return (
        <div
            className={cx("layout-flex-row--centered", "gap-pre-m", {
                ["layout-flex-row--justify-centered"]: isCentered
            })}>
            <Icon size="xl" id="AlertError" className="space-m" />
            <span className="text-error text-font-size-xs">{children}</span>
        </div>
    );
};

export default ValidationMessage;
